<!-- Copyright (C) 2022 by Posit Software, PBC. -->

<template>
  <RSModal
    :active="true"
    subject="Environment Variable Conflict"
    @close="$emit('close')"
  >
    <template #content>
      <div>
        <p>
          Unable to update environment variables because they were changed while you were editing them.
        </p>
        <p>
          Please try again.
        </p>
        <p>
          The environment variable(s) you attempted to change were:
        </p>
        <pre>{{ variables }}</pre>
      </div>
    </template>

    <template #controls>
      <RSButton
        id="ecd-reload"
        label="Reload"
        @click="$emit('close')"
      />
    </template>
  </RSModal>
</template>

<script>
import RSButton from '@/elements/RSButton';
import RSModal from '@/elements/RSModal';

export default {
  name: 'EnvironmentConflictDialog',
  components: { RSButton, RSModal },
  props: {
    variables: {
      type: String,
      required: true,
    },
  },
  emits: ['close'],
  mounted() {
    this.$el.querySelector('button#ecd-reload').focus();
  },
};
</script>
